webpackJsonp([30,47],{

/***/ 1249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var db = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$firebase.database();
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['group'],
  data: function data() {
    return {
      groupMembers: []
    };
  },
  firebase: function firebase() {
    return {
      getMembers: db.ref('groups/' + this.group.groupId).child('members')
    };
  },
  mounted: function mounted() {
    this.members;
  },
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    user: function user() {
      this.$store.getters.getUserDetails;
    },
    isDisabled: function isDisabled() {
      var uid = this.$store.getters.getUserDetails.uid;

      if (this.group.members[uid] && this.group.members[uid].approvalStatus == 1) {
        return true;
      }

      return false;
    },
    canAccessGroup: function canAccessGroup() {
      var groupMembersId = Object.keys(this.group.members);
      var userId = this.$store.getters.getUserDetails.uid;

      if (groupMembersId.includes(userId) && this.group.members[userId].approvalStatus === 1) {
        return true;
      }

      return false;
    },
    members: function members(group) {
      var self = this;
      return this.$firebaseRefs.getMembers.on('value', function (result) {
        if (result.val()) {
          var results = result.val();
          self.groupMembers = results;
        } else {
          self.groupMembers = [];
        }
      });
    }
  },
  methods: {
    joinGroup: function joinGroup(group) {
      var userId = this.$store.getters.getUserDetails.uid;
      var memberPayload = {
        approvalStatus: 0,
        dateAdded: Date.now(),
        memberRole: 'member',
        uid: userId
      };
      var payload = {
        userId: userId,
        groupId: group.groupId,
        member: memberPayload
      };
      this.$store.dispatch('joinGroup', payload);
    },
    goTo: function goTo(link) {
      var id = link.split('/').slice(-1)[0].replace('-', '');
      this.$router.push("/groups/".concat(id));
    },
    showAlert: function showAlert() {
      this.$emit('showAlert');
    }
  }
};

/***/ }),

/***/ 1253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FileUploadComponent__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FileUploadComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FileUploadComponent__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['dialog'],
  components: {
    FileUpload: __WEBPACK_IMPORTED_MODULE_2__components_FileUploadComponent___default.a
  },
  data: function data() {
    return {
      keywords: [],
      groupPhotoUploaded: false,
      groupPhotoFile: '',
      groupPhotoFileName: '',
      groupPhotoFileURL: '',
      categories: ['Construction', 'Defense', 'Finance', 'Information Technology', 'Logistics', 'Manufacturing', 'R&D', 'Retail', 'Service', 'Surplus Dealer', 'Telecommunications', 'Wholesale', 'Total Small Business', 'Competitive 8(a)', 'Veteran-Owned Small Business', 'Service-Disabled Verteran-Owned Small Business', 'Woman Owned Small Business', 'Economically Disadvantaged Woman Owned Small Business'],
      group: {
        name: '',
        members: {},
        coverPhoto: {
          url: 'https://static.pexels.com/photos/380769/pexels-photo-380769.jpeg',
          backgroundPosition: {
            x: '',
            y: ''
          }
        },
        category: null,
        privacy: null,
        description: '',
        admin: {},
        posts: [],
        notifications: [],
        keywords: []
      }
    };
  },
  computed: {
    openModal: function openModal() {
      return this.dialog;
    },
    user: function user() {
      return this.$store.getters.getUserDetails;
    }
  },
  methods: {
    createGroup: function createGroup() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var group, newGroupKey, storageRef, groupPhotoRef, snackbar, imageUrl, _snackbar, _snackbar2, _snackbar3;

        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                group = _this.group;
                group.adminId = _this.user.uid;
                group.members[_this.user.uid] = Object.assign({}, {
                  approvalStatus: 1,
                  memberRole: 'admin',
                  uid: _this.user.uid,
                  dateAdded: Date.now()
                });
                newGroupKey = _this.$firebase.database().ref().child('groups').push().key;
                group.groupId = newGroupKey;
                storageRef = _this.$firebase.storage().ref();
                groupPhotoRef = storageRef.child("groups/".concat(newGroupKey, "/group-photo/attachment.jpg"));
                _context.prev = 7;

                if (!(_this.groupPhotoFileName !== '')) {
                  _context.next = 11;
                  break;
                }

                _context.next = 11;
                return groupPhotoRef.put(_this.groupPhotoFile[0]);

              case 11:
                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](7);
                snackbar = {
                  active: true,
                  text: _context.t0.message
                };

                _this.$store.dispatch('triggerSnackbar', snackbar);

                return _context.abrupt("return", null);

              case 18:
                imageUrl = '';
                _context.prev = 19;

                if (!(_this.groupPhotoFileName !== '')) {
                  _context.next = 24;
                  break;
                }

                _context.next = 23;
                return storageRef.child("groups/".concat(newGroupKey, "/group-photo/attachment.jpg")).getDownloadURL();

              case 23:
                imageUrl = _context.sent;

              case 24:
                _context.next = 31;
                break;

              case 26:
                _context.prev = 26;
                _context.t1 = _context["catch"](19);
                _snackbar = {
                  active: true,
                  text: _context.t1.message
                };

                _this.$store.dispatch('triggerSnackbar', _snackbar);

                return _context.abrupt("return", null);

              case 31:
                group.logo = imageUrl;
                _context.prev = 32;
                _context.next = 35;
                return _this.$firebase.database().ref("groups/".concat(newGroupKey)).set(group);

              case 35:
                _this.content = '';

                _this.cancelGroupPhoto();

                _snackbar2 = {
                  active: true,
                  text: 'Group was created successfully'
                };

                _this.$store.dispatch('triggerSnackbar', _snackbar2);

                _this.group = {
                  name: '',
                  members: {},
                  coverPhoto: {
                    url: 'https://static.pexels.com/photos/380769/pexels-photo-380769.jpeg',
                    backgroundPosition: {
                      x: '',
                      y: ''
                    }
                  },
                  privacy: {},
                  description: '',
                  admin: {},
                  posts: [],
                  notifications: [],
                  keywords: []
                };

                _this.$store.dispatch('toggleGroupModal', false);

                _context.next = 48;
                break;

              case 43:
                _context.prev = 43;
                _context.t2 = _context["catch"](32);
                _snackbar3 = {
                  active: true,
                  text: _context.t2.message
                };

                _this.$store.dispatch('triggerSnackbar', _snackbar3);

                return _context.abrupt("return", null);

              case 48:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 13], [19, 26], [32, 43]]);
      }))();
    },
    cancel: function cancel() {
      this.groupPhotoUploaded = false;
      this.groupPhotoFile = '';
    },
    closeCreateGroupModal: function closeCreateGroupModal() {
      this.$emit('closeCreateGroupModal');
    },
    showGroupPhoto: function showGroupPhoto() {
      if (FileReader && this.groupPhotoFile && this.groupPhotoFile.length) {
        var fr = new FileReader();

        fr.onload = function () {
          this.groupPhotoFileURL = fr.result;
          document.getElementById('imgActivity').src = fr.result;
        };

        fr.readAsDataURL(this.groupPhotoFile[0]);
      }

      this.groupPhotoFileName = this.groupPhotoFile[0].name;
      this.groupPhotoUploaded = false;
    },
    cancelGroupPhoto: function cancelGroupPhoto() {
      this.groupPhotoUploaded = false;
      this.groupPhotoFile = '';
      this.groupPhotoFileName = '';
      this.groupPhotoFileURL = '';
    }
  }
};

/***/ }),

/***/ 1327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GroupViewComponent__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GroupViewComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_GroupViewComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_createGroup_vue__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_createGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_modal_createGroup_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var db = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$firebase.database();
/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      joinedgroups: [],
      publicGroups: [],
      createdGroups: [],
      alert: false,
      openCreateGroupModal: false
    };
  },
  components: {
    GroupView: __WEBPACK_IMPORTED_MODULE_1__components_GroupViewComponent___default.a,
    CreateGroupModal: __WEBPACK_IMPORTED_MODULE_2__components_modal_createGroup_vue___default.a
  },
  firebase: function firebase() {
    return {
      getGroups: db.ref('groups')
    };
  },
  mounted: function mounted() {
    var payload = {
      meta: {
        'h1': 'Groups',
        'title': 'Groups',
        'description': 'Groups Pages',
        'keywords': '',
        'requiresAuth': true
      }
    };
    document.title = payload.meta.title;
    this.$store.commit('setHeaderInfo', payload);
    this.groups;
  },
  methods: {
    openGroup: function openGroup(group) {
      this.$router.push("groups/".concat(group.groupId));
    },
    checkApprovedMember: function checkApprovedMember(group) {
      var obj = this.publicgroups[group.groupId];
      return !obj.members[this.user.uid] || obj.members[this.user.uid].approvalStatus === 0;
    },
    newGroup: function newGroup() {
      this.openCreateGroupModal = true;
    },
    closeCreateGroupModal: function closeCreateGroupModal() {
      this.openCreateGroupModal = false;
    },
    showAlert: function showAlert() {
      this.alert = true;
    }
  },
  computed: {
    privileges: function privileges() {
      return this.$store.getters.getUserPrivileges;
    },
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    groups: function groups() {
      var self = this;
      var userId = this.$store.getters.getUserDetails.uid;
      return this.$firebaseRefs.getGroups.on('value', function (result) {
        if (result.val()) {
          var results = result.val();
          var groupKeys = Object.keys(result.val());
          self.publicGroups = [];
          self.createdGroups = [];
          groupKeys.forEach(function (group) {
            var groupInfo = results[group];
            groupInfo.memberCount = Object.keys(groupInfo.members).length;

            if (groupInfo.members && (Object.keys(groupInfo.members).includes(userId) || groupInfo.privacy.value === 1)) {
              self.publicGroups.push(groupInfo);
            }

            if (groupInfo.adminId === userId) {
              self.createdGroups.push(groupInfo);
            }
          });
          self.publicGroups.sort(function (x, y) {
            return x.name - y.name;
          });
          self.createdGroups.sort(function (x, y) {
            return x.name - y.name;
          });
        } else {
          self.publicGroups = [];
          self.createdGroups = [];
        }
      });
    }
  }
};

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".title-input[data-v-2ee4b31c] ::-webkit-input-placeholder{color:#fff;padding:10px}.title-input[data-v-2ee4b31c] :-ms-input-placeholder{color:#fff;padding:10px}.title-input[data-v-2ee4b31c] :-moz-placeholder{color:#fff;opacity:1;padding:10px}.vertical-center[data-v-2ee4b31c]{position:relative;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}", "", {"version":3,"sources":["/home/circleci/repo/src/components/modal/createGroup.vue"],"names":[],"mappings":"AACA,0DACE,WAAa,AACb,YAAa,CACd,AACD,qDACE,WAAa,AACb,YAAa,CACd,AAMD,gDACE,WAAa,AACb,UAAW,AACX,YAAa,CACd,AACD,kCACE,kBAAmB,AACnB,QAAS,AACT,mCAAoC,AACpC,0BAA4B,CAC7B","file":"createGroup.vue","sourcesContent":["\n.title-input[data-v-2ee4b31c] ::-webkit-input-placeholder { /* Chrome */\n  color: white;\n  padding:10px;\n}\n.title-input[data-v-2ee4b31c] :-ms-input-placeholder { /* IE 10+ */\n  color: white;\n  padding:10px;\n}\n.title-input[data-v-2ee4b31c] :-moz-placeholder { /* Firefox 19+ */\n  color: white;\n  opacity: 1;\n  padding:10px;\n}\n.title-input[data-v-2ee4b31c] :-moz-placeholder { /* Firefox 4 - 18 */\n  color: white;\n  opacity: 1;\n  padding:10px;\n}\n.vertical-center[data-v-2ee4b31c] {\n  position: relative;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".new-group{cursor:pointer}.card_text{min-height:80px;margin-bottom:10px}a{text-decoration:none}.invisible{display:none}.alert{margin-left:30px}.error{background-color:unset!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/groupsView.vue"],"names":[],"mappings":"AACA,WACI,cAAe,CAClB,AACD,WACI,gBAAiB,AACjB,kBAAoB,CACvB,AACD,EACG,oBAAqB,CACvB,AACD,WACI,YAAa,CAChB,AACD,OACI,gBAAkB,CACrB,AACD,OACI,gCAAmC,CACtC","file":"groupsView.vue","sourcesContent":["\n.new-group{\n    cursor:pointer;\n}\n.card_text{\n    min-height: 80px;\n    margin-bottom: 10px;\n}\na{\n\t  text-decoration:none;\n}\n.invisible {\n    display:none;\n}\n.alert {\n    margin-left: 30px;\n}\n.error {\n    background-color: unset !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1454:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1365);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("425297aa", content, true, {});

/***/ }),

/***/ 1461:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1372);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("3f34802c", content, true, {});

/***/ }),

/***/ 1578:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1249),
  /* template */
  __webpack_require__(1730),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1582:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1454)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1253),
  /* template */
  __webpack_require__(1655),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ee4b31c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1655:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": 600,
      "persistent": ""
    },
    model: {
      value: (_vm.openModal),
      callback: function($$v) {
        _vm.openModal = $$v
      },
      expression: "openModal"
    }
  }, [_c('v-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createGroup.apply(null, arguments)
      }
    }
  }, [_c('v-card-title', {
    staticClass: "primary white--text",
    staticStyle: {
      "position": "relative",
      "height": "100px"
    },
    attrs: {
      "dark": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("create")])], 1), _vm._v("\n            Group Cover Image\n          ")], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "position": "absolute",
      "bottom": "-35px",
      "left": "20px"
    },
    attrs: {
      "justify-center": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.groupPhotoUploaded = true
      }
    }
  }, [_c('div', {
    staticClass: "grey lighten-4 text-xs-center",
    staticStyle: {
      "height": "65px",
      "width": "65px",
      "border-radius": "10px"
    }
  }, [_c('v-icon', {
    staticClass: "secondary--text vertical-center"
  }, [_vm._v("assignment")])], 1), _vm._v(" "), (_vm.groupPhotoFile != '') ? _c('v-card', {
    staticClass: "mt-0 pt-0"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "id": "close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelGroupPhoto()
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "15px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "50px",
      "height": "50px"
    },
    attrs: {
      "src": _vm.groupPhotoFileURL,
      "id": "imgActivity"
    }
  })], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-5"
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "white--text title-input",
    staticStyle: {
      "border": "1px solid rgba(255,255,255,0.2)"
    },
    attrs: {
      "required": "",
      "label": "Group Name",
      "prepend-icon": "create"
    },
    model: {
      value: (_vm.group.name),
      callback: function($$v) {
        _vm.$set(_vm.group, "name", $$v)
      },
      expression: "group.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "rows": 3,
      "required": "",
      "multi-line": "",
      "label": "Type a decription for your group",
      "prepend-icon": "create"
    },
    model: {
      value: (_vm.group.description),
      callback: function($$v) {
        _vm.$set(_vm.group, "description", $$v)
      },
      expression: "group.description"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Category",
      "required": "",
      "prepend-icon": "menu",
      "items": _vm.categories
    },
    model: {
      value: (_vm.group.category),
      callback: function($$v) {
        _vm.$set(_vm.group, "category", $$v)
      },
      expression: "group.category"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Type keywords and press enter to add them",
      "prepend-icon": "assignment",
      "items": _vm.keywords,
      "chips": ""
    },
    model: {
      value: (_vm.group.keywords),
      callback: function($$v) {
        _vm.$set(_vm.group, "keywords", $$v)
      },
      expression: "group.keywords"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "label": "Select privacy",
      "required": "",
      "return-object": "",
      "items": [{
        text: 'Public Group',
        value: 1
      }, {
        text: 'Closed Group',
        value: 2
      }]
    },
    model: {
      value: (_vm.group.privacy),
      callback: function($$v) {
        _vm.$set(_vm.group, "privacy", $$v)
      },
      expression: "group.privacy"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "red darken-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeCreateGroupModal()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "type": "submit",
      "color": "blue darken-1"
    }
  }, [_vm._v("Create")])], 1), _vm._v(" "), _c('file-upload', {
    attrs: {
      "trigger": _vm.groupPhotoUploaded,
      "formats": ['jpeg', 'png', 'jpg']
    },
    on: {
      "update:trigger": function($event) {
        _vm.groupPhotoUploaded = $event
      },
      "cancel": _vm.cancel,
      "confirm": function($event) {
        return _vm.showGroupPhoto()
      }
    },
    model: {
      value: (_vm.groupPhotoFile),
      callback: function($$v) {
        _vm.groupPhotoFile = $$v
      },
      expression: "groupPhotoFile"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1664:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-5 mt-5",
    style: ({
      backgroundColor: _vm.styles.general.background_color
    }),
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mx-5",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-flex', {
    staticClass: "ml-4 ",
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "34px",
      "font-weight": "900"
    }
  }, [_vm._v("Groups")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "ml-4",
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "18px",
      "line-height": "120%",
      "font-weight": "400",
      "margin": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-10px",
      "padding-top": "0px"
    }
  }, [_vm._v("\n          Groups are great for getting things done and staying in touch with just the people you want. Share photos and videos,\n          have conversations, make plans and more.\n        ")])]), _vm._v(" "), _c('v-flex', [_c('v-alert', {
    style: ({
      'background-color': _vm.styles.general.theme_color_dark + '!important'
    }),
    attrs: {
      "icon": "warning",
      "dismissible": "",
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }, [_vm._v("\n          You cannot access this group as are not a member yet!\n        ")])], 1)], 1), _vm._v(" "), (_vm.privileges.groups && _vm.privileges.groups.create_group) ? _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-btn', {
    staticClass: "white my-4",
    staticStyle: {
      "height": "70px",
      "text-transform": "capitalize",
      "float": "right",
      "font-size": "18px"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.newGroup()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("add")]), _vm._v("\n        Create a Group\n      ")], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mx-4 mt-3"
  }, [_c('v-card', {
    staticClass: "mx-5",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-tabs', {
    attrs: {
      "scrollable": false,
      "fixed": ""
    }
  }, [_c('v-tab', {
    staticClass: "mx-2",
    attrs: {
      "href": "#tab-1"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-size": "16px"
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("assignment")]), _vm._v("\n            Groups \n          ")], 1)]), _vm._v(" "), _c('v-tab', {
    staticClass: "mx-2",
    attrs: {
      "href": "#tab-2"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-size": "16px"
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("assignment")]), _vm._v("\n            Your Groups \n          ")], 1)]), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "tab-1"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, _vm._l((_vm.publicGroups), function(group) {
    return _c('group-view', {
      key: group.groupId,
      attrs: {
        "group": group
      },
      on: {
        "showAlert": _vm.showAlert
      }
    })
  }), 1)], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "tab-2"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.createdGroups), function(group) {
    return _c('group-view', {
      key: group.groupId,
      attrs: {
        "group": group
      },
      on: {
        "showAlert": _vm.showAlert
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.openCreateGroupModal) ? _c('div', [_c('create-group-modal', {
    attrs: {
      "dialog": _vm.openCreateGroupModal
    },
    on: {
      "update:dialog": function($event) {
        _vm.openCreateGroupModal = $event
      },
      "closeCreateGroupModal": _vm.closeCreateGroupModal
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1730:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "ml-2",
    staticStyle: {
      "min-height": "150px"
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "150px"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "mr-2 text-xs-center",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "130px",
      "border-radius": "15px",
      "border": "1px solid black",
      "overflow": "hidden",
      "background-color": "#d1d1d1"
    },
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('img', {
    staticStyle: {
      "overflow-y": "hidden",
      "width": "100%"
    },
    attrs: {
      "src": _vm.group.coverPhoto.url
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4 pl-4",
    staticStyle: {
      "margin-left": "-20px"
    },
    attrs: {
      "xs7": ""
    }
  }, [(_vm.canAccessGroup) ? _c('h6', {
    staticStyle: {
      "font-weight": "900",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo(("" + (_vm.group.groupId)))
      }
    }
  }, [_vm._v(_vm._s(_vm.group.name))]) : _c('h6', {
    staticStyle: {
      "font-weight": "900",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showAlert.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.group.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("group")]), _vm._v("  " + _vm._s(Object.keys(_vm.groupMembers).length) + " Members\n        ")], 1)]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "height": "20%"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "large": "",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.joinGroup(_vm.group)
      }
    }
  }, [_c('v-layout', {
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("add")]), _vm._v("\n              Join \n          ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "height": "20%"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "large": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("favorite")]), _vm._v("\n            Favorite\n          ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-2",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "height": "20%"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "large": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("share")]), _vm._v("\n            Share\n          ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider', {
    staticClass: "my-2"
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1461)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1327),
  /* template */
  __webpack_require__(1664),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 948:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['trigger', 'formats'],
  data: function data() {
    return {
      filePicker: true
    };
  },
  computed: {
    dialog: function dialog() {
      return this.trigger;
    }
  },
  methods: {
    confirm: function confirm() {
      var _this = this;

      if (this.$refs.pick.files.length === 0) {
        var snackbar = {
          active: true,
          text: 'Please add a file'
        };
        this.$store.dispatch('triggerSnackbar', snackbar);
        return;
      }

      var truth = this.formats.map(function (val) {
        return val === _this.$refs.pick.files[0].type.split('/')[1].toLowerCase();
      });
      var supported = false;
      truth.forEach(function (val) {
        supported = supported || val;
      });

      if (!supported) {
        var _snackbar = {
          active: true,
          text: 'Invaid file type'
        };
        this.$store.dispatch('triggerSnackbar', _snackbar);
        return;
      }

      this.$emit('confirm');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    pickFile: function pickFile() {
      this.$refs.pick.click();
    },
    broadcastInput: function broadcastInput() {
      this.$emit('input', [this.$refs.pick.files[0]]);
    }
  }
};

/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(948),
  /* template */
  __webpack_require__(959),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 959:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('form', {
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.confirm()
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pb-0"
  }, [_c('input', {
    ref: "pick",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.broadcastInput()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pickFile()
      }
    }
  }, [_c('v-icon', {
    staticClass: "text-xs-justify",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("backup")])], 1), _vm._v(" "), _c('h6', {
    staticClass: "text-xs-center mt-2"
  }, [_vm._v("Click to choose a file")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("* " + _vm._s(_vm.formats.toString()))])], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit"
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/30.d03bda0c1badc7494b4c.js